<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-if="loading_page === false">
      <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert" v-if="alert_success === true">เปลี่ยนสถานะเรียบร้อย !</v-alert>
      </v-slide-x-reverse-transition>
      <div>
        <v-card elevation="6">
          <div class="grid_btn_header pa-4">
            <div class="grid_btn_size">
              <v-btn x-large class="text-center grad-success-bg white--text btn_size ml-2" to="/stock/storage/addproducttostock">
                เพิ่มสินค้าเข้าคลัง
              </v-btn>
            </div>
            <div class="grid_notification">
              <v-btn x-large @click="getNotify()" class="filled_btn btn_notification ml-2">
                <div class="btn_size count_all filed_number white--text">{{ getExpire }}</div>
                <span class="btn_size red--text">สินค้ารอย้ายเข้าคลังใกล้หมดอายุ</span>
              </v-btn>
            </div>
          </div>
          <div class="pa-4">
            <v-card-title>
              รายการสินค้า
            </v-card-title>
            <v-card-title>
              <v-text-field v-model="search" color="#86bc3a" append-icon="mdi-magnify" label="ค้นหา" single-line hide-details></v-text-field>
            </v-card-title>
            <v-data-table :headers="productHeaders" :items="getProduct_list" :footer-props="footer_Props" :search="search" mobile-breakpoint="0">
              <template v-slot:item="dataDetail" class="grid_btn">
                <tr>
                  <td>{{ dataDetail.item.product_code }}</td>
                  <td>{{ dataDetail.item.product_name }}</td>
                  <td>{{ format_number(dataDetail.item.quantity) }}</td>
<!--                  <td>-->
<!--                    <v-switch color="#86bc3a" @change="changeStatus(dataDetail.item.product_id, dataDetail.item.product_status)" v-model="dataDetail.item.product_status" :disabled="disabled_status"></v-switch>-->
<!--                  </td>-->
                  <td class="pa-3">
                    <v-btn @click="getDetails(dataDetail.item.product_id)" class="pa-6 grad-success-bg white--text">
                      <v-icon>mdi-magnify</v-icon> ดูรายละเอียด
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </div>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>

import {HTTP} from "@/axios";
import {formatNumber} from "@/js/handler";
import Swal from "sweetalert2";

export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "Storage",
  data() {
    return {
      search: null,
      loading_page: false,
      alert_success: false,
      disabled_status: false,
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        'items-per-page-text':'รายการต่อหน้า'
      },
      getProduct_list: [],
      getExpire: 0,
      productHeaders: [
        {
          text: 'รหัส',
          align: 'start',
          value: 'product_code',
          fixed: true,
          width: '120px',
        },
        {
          text: 'ชื่อสินค้า',
          value: 'product_name',
          fixed: true,
          width: '200px',
        },
        {
          text: 'จำนวน',
          value: 'quantity',
          fixed: true,
          width: '120px',
        },
        // {
        //   text: 'สถานะขาย',
        //   value: 'status',
        //   sortable: false,
        //   fixed: true,
        //   width: '110px',
        // },
        {
          text: 'จัดการ',
          value: '',
          sortable: false,
          fixed: true,
          width: '150px',
        },
      ],
    }
  },
  methods: {
    format_number: function (value) {
      return formatNumber(value)
    },
    checkLoading() {
      this.loading_page = true
      HTTP.post('/inventory/getmain').then((res) => {
        if (res.data.success === true) {
          this.loading_page = false
          this.getExpire = res.data.countGetExp;
          this.getProduct_list = res.data.object;
        }
      })
    },
    // getExpire_length() {
    //   HTTP.post('/inventory/getexp')
    //       .then((res) => {
    //         if (res.data.success === true) {
    //           let value = res.data.object.length
    //           if (value < 10) {
    //             this.getExpire = '0' + value
    //           }else if(value > 100) {
    //             this.getExpire = '99+'
    //           }
    //         }
    //       })
    // },
    getProduct() {
      HTTP.post('/inventory/getmain').then((res) => {
        if (res.data.success === true) {
          this.getExpire = res.data.countGetExp;
          this.getProduct_list = res.data.object;
        }
      })
    },
    getDetails(id) {
      this.$router.push('/stock/storage/details/' + id);
    },
    changeStatus(product_id, status) {
      if (status == true) {
        this.status_id = 1;
      }
      else if (status == false) {
        this.status_id = 0;
      }
      this.disabled_status = true
      HTTP.post('/products/product/changestatus', {
        status: this.status_id,
        product_id: product_id
      }).then((res) => {
        if (res.data.success === true){
          this.disabled_status = false
          this.alert_success = true;
          setTimeout(() => this.alert_success = false, 3000);
        }
        else {
          Swal.fire({
            title: 'ไม่สามารถดำเนินการได้ !',
            text: res.data.message,
            icon: 'error',
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: `ตกลง`,
            denyButtonText: `ยกเลิก`,
          }).then(() => {
            this.disabled_status = false
            this.getProduct()
          })
        }
      })
    },
    getNotify() {
      this.$router.push('/stock/storage/expstorage')
    }
  },
  beforeMount() {
    this.checkLoading();
    // this.getExpire_length();
  }
}
</script>

<style scoped>
.alert {
  margin: 0;
  position: fixed !important;
  z-index: 9999;
  top: 15px;
  right: 5px;
}
.grid_btn {
  display: grid;
  grid-template-columns: 100%;
}
.btn_size {
  font-size: 16px;
}

.btn_notification {
  font-size: 1.0vw;
  background-color: white !important;
}

.count_all{
  border: 3px solid;
  border-radius: 20px;
  padding-right: 5px;
  padding-left: 5px;
  margin-right: 5px;
}

.grid_btn_header {
  display: grid;
  grid-template-columns: 50% 50%;
}

.grid_btn_size {
  display: grid;
  grid-template-columns: 33.33% 33.33% 33.33%;
}

.grid_notification {
  display: grid;
  grid-template-columns: 100%;
  justify-items: end;
}

.filled_btn {
  border: 2px solid red;
  color: red;
}

.filed_number {
  background-color: red;
  border: 2px solid red;
}

.btn_notification {
  background-color: white !important;
}
@media only screen and (max-width: 1024px) {
  .grid_btn_size {
    display: grid;
    grid-template-columns: 50% 50%;
    grid-gap: 15px 0;
  }
  .btn_size {
    font-size: 1.7vw;
  }
}
@media only screen and (max-width: 600px) {
  .grid_btn_header {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }
  .grid_btn_size {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }
  .btn_size {
    font-size: 16px;
  }
  .grid_notification {
    display: grid;
    grid-template-columns: 100%;
    justify-items: normal;
  }
}
</style>
